/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "nightsense_manager";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface NightsenseRequestedState {
}

export enum NightsenseRequestedState_Enum {
  UNKNOWN = 0,
  ENABLE = 1,
  DISABLE = 2,
  TEMPORARILY_DISABLE = 3,
  UNRECOGNIZED = -1,
}

export function nightsenseRequestedState_EnumFromJSON(object: any): NightsenseRequestedState_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return NightsenseRequestedState_Enum.UNKNOWN;
    case 1:
    case "ENABLE":
      return NightsenseRequestedState_Enum.ENABLE;
    case 2:
    case "DISABLE":
      return NightsenseRequestedState_Enum.DISABLE;
    case 3:
    case "TEMPORARILY_DISABLE":
      return NightsenseRequestedState_Enum.TEMPORARILY_DISABLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NightsenseRequestedState_Enum.UNRECOGNIZED;
  }
}

export function nightsenseRequestedState_EnumToJSON(object: NightsenseRequestedState_Enum): string {
  switch (object) {
    case NightsenseRequestedState_Enum.UNKNOWN:
      return "UNKNOWN";
    case NightsenseRequestedState_Enum.ENABLE:
      return "ENABLE";
    case NightsenseRequestedState_Enum.DISABLE:
      return "DISABLE";
    case NightsenseRequestedState_Enum.TEMPORARILY_DISABLE:
      return "TEMPORARILY_DISABLE";
    case NightsenseRequestedState_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseNightsenseRequestedState(): NightsenseRequestedState {
  return {};
}

export const NightsenseRequestedState = {
  encode(_: NightsenseRequestedState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NightsenseRequestedState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNightsenseRequestedState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): NightsenseRequestedState {
    return {};
  },

  toJSON(_: NightsenseRequestedState): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<NightsenseRequestedState>, I>>(base?: I): NightsenseRequestedState {
    return NightsenseRequestedState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NightsenseRequestedState>, I>>(_: I): NightsenseRequestedState {
    const message = createBaseNightsenseRequestedState();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
